import React from 'react';
import { Dialog, IconButton, Typography, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import dayjs from 'dayjs';
import NoData from '../../../Components/Nodata';

interface Note {
  note: string;
  noteFor: string;
  userId: string;
  name: string;
  userType: string;
  _id: string;
  createdAt: string;
  updatedAt: string;
}

interface ViewNotesModalProps {
  open: boolean;
  onClose: () => void;
  notes: any;
  worksheetTitle?: string;
}

const ViewNotesModal: React.FC<ViewNotesModalProps> = ({
  open,
  onClose,
  notes,
  worksheetTitle = 'Worksheet Notes',
}) => {
  const formatTimeAgo = (dateString: string) => {
    const now = dayjs();
    const date = dayjs(dateString);

    if (!date.isValid()) return 'Invalid date';

    const diffInMinutes = now.diff(date, 'minute');
    const diffInHours = now.diff(date, 'hour');
    const diffInDays = now.diff(date, 'day');

    if (diffInMinutes < 2) {
      return 'Just now';
    } else if (diffInHours < 1) {
      return `Uploaded ${diffInMinutes} min${diffInMinutes > 1 ? 's' : ''} ago`;
    } else if (diffInHours < 24) {
      return `Uploaded ${diffInHours} hr${diffInHours > 1 ? 's' : ''} ago`;
    } else if (diffInDays < 7) {
      return `Uploaded ${diffInDays} day${diffInDays > 1 ? 's' : ''} ago`;
    } else {
      return `Uploaded on ${date.format('MMM DD, YYYY | h:mm A')}`;
    }
  };

  const getNoteForColor = (noteFor: string) => {
    switch (noteFor) {
      case 'PUBLIC':
        return '#4CAF50';
      case 'PRIVATE':
        return '#FF9800';
      case 'INTERNAL':
        return '#2196F3';
      default:
        return '#757575';
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth className="modal-main">
      <div className="modal-dialog large">
        <div className="modal-content">
          <div className="modal-title d-flex align-center flex-between">
            <p className="">
              <span className="highlight">All</span> Notes
            </p>

            <IconButton onClick={onClose} className="close-button">
              <CloseIcon />
            </IconButton>
          </div>

          <div className="modal-body">
            <div className="body-scroll-sm">
              {notes &&
              notes.length > 0 &&
              notes?.some((note: any) => note?.note) ? (
                <Box className="notes-container">
                  {notes?.map((note: any, index: any) => {
                    return note?.note ? (
                      <div key={note?._id + index} className="note-card">
                        {/* Note Header */}

                        <div className="note-info">
                          <h1 className="fw600 MuiTypography-body2 mb-6">
                            {note?.name}
                          </h1>
                          <p className="MuiTypography-subtitle3 text-text mb-8">
                            {formatTimeAgo(note?.createdAt)}
                          </p>
                        </div>

                        {/* Note Content */}
                        <p className="MuiTypography-subtitle1 text-text">
                          {note?.note}
                        </p>
                      </div>
                    ) : null;
                  })}
                </Box>
              ) : (
                <Box className="no-notes-container">
                  <Typography variant="body2">
                    <NoData
                      heading="No Notes Available"
                      title="There are no notes for this shift yet."
                    />
                  </Typography>
                </Box>
              )}
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default ViewNotesModal;
